// extracted by mini-css-extract-plugin
module.exports = {"Image":"DetailsPhoto_Image__11rdI","Wrapper":"DetailsPhoto_Wrapper__38420","Switcher":"DetailsPhoto_Switcher__3f7t7"};